var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogo = function SvgLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#logo_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 2,
    d: "M47.907 38.024 27.842 3.273a.31.31 0 0 0-.268-.156h-7.2a.31.31 0 0 0-.27.156L.042 38.024a.31.31 0 0 0 0 .312l3.599 6.233a.31.31 0 0 0 .27.156h7.198c.112 0 .214-.06.27-.156l3.51-6.078h18.173l3.51 6.078a.31.31 0 0 0 .27.156h7.197c.113 0 .215-.06.27-.156l3.6-6.233a.32.32 0 0 0-.002-.312Zm-.81-.156h-6.48l-3.51-6.078a.31.31 0 0 0-.27-.156H18.845l3.24-5.61h11.153a.313.313 0 0 0 .27-.468L20.915 3.74h6.48zM25.501 25.401h-3.056l1.527-2.648zM20.374 4.052 32.7 25.401h-6.479l-5.577-9.66a.313.313 0 0 0-.54 0L3.91 43.79.67 38.18zm-5.666 33.816a.31.31 0 0 0-.27.156l-3.51 6.078H4.45L20.374 16.52l3.24 5.61-5.578 9.66a.313.313 0 0 0 .27.468H36.3l-1.111 1.924-2.128 3.686zM36.84 32.57l.735 1.274 2.504 4.337-3.24 5.61-3.239-5.61zm7.017 11.533h-6.48l1.081-1.87 2.16-3.74h6.478z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "logo_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h48v48H0z"
  })))));
};
export default SvgLogo;